import { useEffect, useState } from "react";
import TabMenuAdmin from "../TabMenuAdmin/TabMenuAdmin";
import TableWithdrawalRequest from "./components/TableWithdrawalRequest";
import {actuallyResponseWithdrawalIdLotteryIdUserRequestService,getAllWithdrawalRequestService,} from "./services/withdrawalRequest.service";
import {ActuallyResponseIdLotteryIdUserRequest,WithdrawalRequest,} from "../../../Transfer/models/transfer.model";
import { Dialog } from "primereact/dialog";
import FormEditWitdrawalRequest from "./components/FormEditWitdrawalRequest";
import { useNavigate } from "react-router-dom";
import ToastBackControl from "../../../../components/Sidebar/ToastBackControl/ToastBackControl";
import { ToastControlBackendModel } from "../../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";
import { withdrawalRequestTableResponseDataAdapter } from "./adapters/withdrawalRequest.adapter";
import TableActuallyWithdrawalRequest from "./components/TableActuallyWithdrawalRequest";
import FormAddNewResponseRequest from "./components/FormAddNewResponseRequest";

const viewStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  .admin-withdrawal-root-container {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background-color: #f8fafc !important;
    min-height: 100vh;
    width: 100%;
    color: #1e293b;
  }

  .clean-light-table .p-datatable,
  .clean-light-table .p-datatable-thead > tr > th,
  .clean-light-table .p-datatable-tbody > tr,
  .clean-light-table .p-datatable-tbody > tr > td,
  .clean-light-table .p-datatable-header {
    background-color: #ffffff !important;
    color: #334155 !important;
    border-color: #f1f5f9 !important;
  }

  .clean-light-table .p-datatable-thead > tr > th {
    background-color: #f8fafc !important;
    font-weight: 700 !important;
    color: #1e293b !important;
  }

  .clean-light-table .p-datatable {
    border: none !important;
    box-shadow: none !important;
  }

  .p-datatable-header .p-inputtext,
  .custom-withdrawal-dialog .p-inputtext {
    background-color: #ffffff !important;
    color: #334155 !important;
    border: 1px solid #cbd5e1 !important;
    border-radius: 6px !important;
  }

  .p-datatable-header .p-inputtext::placeholder {
    color: #94a3b8 !important;
  }

  .custom-withdrawal-dialog .p-calendar .p-inputtext {
    background-color: #ffffff !important;
    color: #334155 !important;
    border: 1px solid #cbd5e1 !important;
    border-radius: 6px 0 0 6px !important;
    padding: 0.75rem 1rem !important;
  }

  .p-datepicker {
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
    padding: 0.35rem !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
  }

  .p-datepicker table th,
  .p-datepicker table td {
    padding: 1.5px !important;
  }

  .p-datepicker table td > span {
    width: 2rem !important;
    height: 2rem !important;
    line-height: 2rem !important;
    font-size: 0.82rem !important;
    border-radius: 50% !important;
  }

  .p-datepicker .p-datepicker-header,
  .p-datepicker table th,
  .p-datepicker table td {
    color: #1e293b !important;
  }

  .p-datepicker table th span {
    color: #64748b !important;
    font-weight: 600 !important;
    font-size: 0.78rem !important;
  }

  .p-datepicker table td.p-datepicker-other-month span {
    color: #cbd5e1 !important;
  }

  .p-datepicker table td > span:not(.p-disabled):not(.p-highlight):hover {
    background: #f1f5f9 !important;
    color: #1e293b !important;
  }

  .p-datepicker table td > span.p-highlight {
    background: #00A86B !important;
    color: #ffffff !important;
  }

  .custom-withdrawal-dialog .p-inputtext:focus,
  .custom-withdrawal-dialog .p-calendar .p-inputtext:focus {
    outline: none !important;
    border-color: #00A86B !important;
    box-shadow: 0 0 0 2px rgba(0, 168, 107, 0.15) !important;
  }

  .custom-withdrawal-dialog .p-button.p-button-icon-only {
    background-color: #f1f5f9 !important;
    border: 1px solid #cbd5e1 !important;
    border-left: none !important;
    color: #64748b !important;
  }

  .custom-withdrawal-dialog .p-button:not(.p-button-icon-only) {
    background-color: #00A86B !important;
    border-color: #00A86B !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    border-radius: 6px !important;
    transition: background-color 0.2s !important;
    width: 100% !important;
  }

  .custom-withdrawal-dialog .p-button:not(.p-button-icon-only):hover {
    background-color: #008f5b !important;
    border-color: #008f5b !important;
  }

  .custom-withdrawal-dialog .p-button:disabled {
    background-color: #cbd5e1 !important;
    border-color: #cbd5e1 !important;
    color: #ffffff !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
  }
`;

function AdminWithdrawalRequest(): JSX.Element {
  const isAdminValue = localStorage.getItem("isAdmin");
  const navigate = useNavigate();
  const [dataWithdrawalResponse, setDataWithdrawalResponse] = useState<WithdrawalRequest[]>([]);
  const [dataWithdrawalResponseRow, setDataWithdrawalResponseRow] = useState<WithdrawalRequest>();
  const [actuallyDataWithdrawalResponse, setActuallyDataWithdrawalResponse] = useState<WithdrawalRequest[]>();

  const [dialogResponse, setDialogResponse] = useState<boolean>(false);
  const [dataWithResponseRow, setDataWithResponseRow] = useState<WithdrawalRequest>();
  const [dialogWithResponse, setDialogWithResponse] = useState<boolean>(false);

  const [messageBackend, setMessageBackend] = useState<ToastControlBackendModel>({
    severityValue: "info",
    detailValue: "",
    lifeValue: 3000,
    validateShowMessage: false,
  });

  const getAllWithdrawalRequest = async (): Promise<void> => {
    const response = await getAllWithdrawalRequestService();
    if (response) {
      setDataWithdrawalResponse(withdrawalRequestTableResponseDataAdapter(response));
    }
  };

  const actuallyResponseLottery = async (data: ActuallyResponseIdLotteryIdUserRequest) => {
    try {
      const response = await actuallyResponseWithdrawalIdLotteryIdUserRequestService(data);
      if (response) {
        setActuallyDataWithdrawalResponse(response);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (isAdminValue !== "1") {
      navigate("/");
    }
    getAllWithdrawalRequest().catch(() => {});
  }, []);
  
  const handleCloseDialogResponse = () => {
  setDialogResponse(false);
  setDataWithdrawalResponseRow(undefined); 
};

  return (
    <div className="admin-withdrawal-root-container">
      <style>{viewStyles}</style>
      <TabMenuAdmin />

      <main className="w-full flex flex-column px-3 md:px-5 py-4">
        <div className="flex align-items-center justify-content-between pb-4 border-bottom-1 surface-border mb-4">
          <div className="flex align-items-center gap-3">
            <div
              className="flex align-items-center justify-content-center p-2 border-round-lg shadow-1"
              style={{ backgroundColor: "#e6faf2", color: "#00A86B" }}
            >
              <i className="pi pi-money-bill text-xl"></i>
            </div>
            <div className="flex flex-column justify-content-center">
              <h1
                className="text-xl md:text-2xl font-bold m-0 tracking-tight"
                style={{ color: "#1e293b" }}
              >
                Solicitudes de Retiro
              </h1>
              <p className="text-sm text-500 m-0 mt-1 hidden sm:block">
                Gestiona, aprueba y haz seguimiento a los retiros solicitados por los usuarios del sistema.
              </p>
            </div>
          </div>
        </div>

        {messageBackend.validateShowMessage && (
          <ToastBackControl
            validateShowMessage={messageBackend.validateShowMessage}
            detailValue={messageBackend.detailValue}
            lifeValue={messageBackend.lifeValue}
            severityValue={messageBackend.severityValue}
          />
        )}

        <div className="bg-white p-4 border-round-xl shadow-1 w-full clean-light-table">
          <TableWithdrawalRequest
            setDialogResponse={setDialogResponse}
            setDataWithoutResponseRow={setDataWithdrawalResponseRow}
            dataWithoutResponse={dataWithdrawalResponse}
            setDataWithResponseRow={setDataWithResponseRow}
            setDialogWithResponse={setDialogWithResponse}
            actuallyResponseLottery={actuallyResponseLottery}
          />
        </div>

        {dataWithdrawalResponseRow && (
          <Dialog
            header={`Respuesta a solicitud de retiro #${dataWithdrawalResponseRow?.idWithdrawalRequest}`}
            visible={dialogResponse}
            onHide={handleCloseDialogResponse}
            className="w-full max-w-30rem mx-3 custom-withdrawal-dialog"
            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
            draggable={false}
            resizable={false}
            pt={{
              root: { style: { backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e5e7eb", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1)" } },
              header: { style: { backgroundColor: "#ffffff", color: "#1f2937", borderBottom: "1px solid #e5e7eb", padding: "1.25rem 1.5rem" } },
              content: { style: { backgroundColor: "#ffffff", padding: "1.5rem" } },
              closeButtonIcon: { style: { color: "#1f2937" } },
            }}
          >
            <FormEditWitdrawalRequest
              getAllWithdrawalRequestData={getAllWithdrawalRequest} 
              setDialogEditWithdrawalRequest={handleCloseDialogResponse} 
              idWithdrawalRequest={dataWithdrawalResponseRow?.idWithdrawalRequest}
              setMessageBackend={setMessageBackend}
            />
          </Dialog>
        )}

        {dataWithResponseRow && (
          <Dialog
            header={`Historial de respuestas - Retiro #${dataWithResponseRow?.idWithdrawalRequest}`}
            visible={dialogWithResponse}
            onHide={() => setDialogWithResponse(false)}
            className="w-full max-w-40rem mx-3 custom-withdrawal-dialog"
            breakpoints={{ "960px": "85vw", "641px": "100vw" }}
            draggable={false}
            resizable={false}
            pt={{
              root: { style: { backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e5e7eb", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1)" } },
              header: { style: { backgroundColor: "#ffffff", color: "#1f2937", borderBottom: "1px solid #e5e7eb", padding: "1.25rem 1.5rem" } },
              content: { style: { backgroundColor: "#ffffff", padding: "1.5rem" } },
              closeButtonIcon: { style: { color: "#1f2937" } },
            }}
          >
            {actuallyDataWithdrawalResponse ? (
              <div className="flex flex-column gap-4">
                <FormAddNewResponseRequest
                  ActuallyResponseDatarow={dataWithResponseRow}
                  setDialogWithResponse={setDialogWithResponse}
                  getAllWithdrawalRequestData={getAllWithdrawalRequest}
                  setMessageBackend={setMessageBackend}
                />
                <div className="border-top-1 surface-border pt-3 clean-light-table">
                  <TableActuallyWithdrawalRequest
                    actuallyDataWithdrawalResponse={withdrawalRequestTableResponseDataAdapter(
                      actuallyDataWithdrawalResponse
                    )}
                  />
                </div>
              </div>
            ) : (
              <h2 className="text-center text-muted py-4">No hay resultados</h2>
            )}
          </Dialog>
        )}
      </main>
    </div>
  );
}

export default AdminWithdrawalRequest;